export * from './BookClosedHelpIcon';
export * from './BookClosedHelpIcon16Light';
export * from './BookClosedHelpIcon16Regular';
export * from './BookClosedHelpIcon16Solid';
export * from './BookClosedHelpIcon20Light';
export * from './BookClosedHelpIcon20Regular';
export * from './BookClosedHelpIcon20Solid';
export * from './BookClosedHelpIcon24Regular';
export * from './BookClosedHelpIcon24Solid';
export * from './BookClosedHelpIcon32Regular';
export * from './BookClosedHelpIcon64Regular';
